export const acceptedImageTypes = ['.jpg', '.jpeg', '.png', '.svg', '.gif', '.webp', '.avif', '.jfif', '.bmp'];
export const acceptedVideoTypes = ['.mp4', '.webm', '.avi', '.mov', '.mkv', '.ogv'];
//Make sure its the same as switch case in pageStore.ts ln 671
